/*
 * This file is part of ORY Editor.
 *
 * ORY Editor is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * ORY Editor is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with ORY Editor.  If not, see <http://www.gnu.org/licenses/>.
 *
 * @license LGPL-3.0
 * @copyright 2016-2018 Aeneas Rekkas
 * @author Aeneas Rekkas <aeneas+oss@aeneas.io>
 *
 */
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var computeOrder = function (_a) {
    var rows = _a.rows, cells = _a.cells, _b = _a.content, _c = (_b === void 0 ? {} : _b).plugin, _d = (_c === void 0 ? {} : _c).name, name = _d === void 0 ? '' : _d, id = _a.id;
    return __spreadArrays([
        [
            {
                id: id,
                isLeaf: Boolean(name),
            },
        ]
    ], (rows || []).map(computeOrder), (cells || []).map(computeOrder)).reduce(function (p, n) { return __spreadArrays(p, n); }, []);
};
// tslint:disable-next-line:no-any
export var cellOrder = function (os) {
    return os
        .map(computeOrder)
        // tslint:disable-next-line:no-any
        .reduce(function (p, n) { return __spreadArrays(p, n); }, []);
};
//# sourceMappingURL=order.js.map